import { getReal, setReal } from '@utils/storage.js';
import { UPDATEREAL, REMOVEREAL } from '../types';
export default {
  namespaced: true,
  state: {
    realInfo: getReal() || {}
  },
  mutations: {
    [UPDATEREAL] (state, realInfo) {
      state.realInfo = Object.assign({}, state.realInfo, realInfo);
      setReal(state.realInfo);
    },
    [REMOVEREAL] (state) {
      state.realInfo = {};
      setReal('');
    }
  },
  actions: {
    updateReal ({ commit }, realInfo) {
      commit(UPDATEREAL, realInfo);
    },
    removeReal ({ commit }) {
      commit(REMOVEREAL);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/real.js